export const microServicesRoutes = {
  edge: {
    get: {
      agent: {
        callSessionValidations: '/users/agent-validations',
      },
      users: {
        userNest: '/users',
        getUserNestConsole: '/users/getForManagement',
        usersByIds: '/users/by-ids',
        allActiveSdrs: '/users/active/sdrs',
      },
      organizations: {
        getById: '/organization',
        getForManagementNest: '/organization/page/management',
        getAllActiveOrganizations: '/organization',
      },
      twilio: {
        token: '/twilio/token',
        iceToken: '/twilio/ice-servers',
        currentNumber: '/twilio/current/number',
        participants: '/twilio/participants',
        terminateConference: '/twilio/conference',
        callerId: {
          getNumbers: '/numbers/current/user'
        }
      },
      auth: {
        loggerToken: '/auth/logger-token',
      },
      numbers: {
        numbersNest: '/numbers',
        callerId: {
          numbers: '/numbers/user',
        }
      },
      calendar: {
        getSessions: '/calendar/calendly-sessions',
      }
    },
    post: {
      auth: {
        login: '/auth/login',
      },
      users: {
        createUser: '/users',
        uploadProfilePicture: '/uploader/userProfilePic',
      },
      recordings: {
        playRecordingNest: '/twilio',
      },
      twilio: {
        transferCallNest: '/twilio/call',
        caller: '/twilio/caller',
        validate: '/twilio/validate',
        wait: '/twilio/wait',
        registryCallerId: '/twilio/caller',
        validateNumber: '/twilio/validate',
      },
      organizations: {
        createOrganization: '/organization',
      },
      numbers: {
        numbersNest: '/numbers',
      },
    },
    put: {
      twilio: {
        updateNumber: '/numbers',
      },
      users: {
        updateUser: '/users',
        password: {
          changeUserPassword: '/auth/update',
        },
      },
      organizations: {
        updateOrganization: '/organization',
      },
      numbers: {
        numbersNest: '/numbers',
      },
    },
    delete: {
      twilio: {
        deleteNumberUser: '/twilio/user',
      },
      numbers: {
        numbersNest: '/numbers',
      },
      users: {
        deleteUserNest: '/users',
      },
      organizations: {
        deleteOrganization: '/organization',
      },
    },
  },

  contacts: {
    get: {
      rabbit: {
        consumeNest: '/rabbit/consume',
      },
      dashboard: {
        getSessions: '/dashboard/sdrId',
        getSessionDetails: '/dashboard/session-details',
        sessionContactSummary: '/dashboard/session',
        getRecordings: '/dashboard/recordings',
        overviewKpis: '/overview/kpis',
        overviewLeaderboard: '/overview/leaderboard',
      },
      callLogs: {
        callsBySession: '/call-logs/calls-by-session',
        byCallSessionId: '/call-logs/callSessionId',
        sdrCallLog: '/call-logs/sdr',
      },
      callSession: {
        getByStatusAndAgentIdNest: '/call-sessions/getByStatusAndAgentId',
        getByIdNest: '/call-sessions/callSessionId',
        getActiveCallSessions: '/call-sessions/activeCallSessions',
        getByMultipleStatusAndSdrId: '/call-sessions/getByMultipleStatusAndSdrId',
        getRecycleContactsLists: '/call-sessions/recycle-contacts',
        getDialingStatus: '/call-sessions/getDialingStatus',
        getReport: '/call-sessions/getReport',
      },
      callSessionConfig: {
        getByCallSessionId: '/call-session-configs/call-session',
      },
      recordings: {
        getRecordingByCallId: '/recording/callId',
        getRecordingsBySdrIdNest: '/recording/sdr',
        getRecordingById: '/recording',
        getRecordingExclusionRule: '/recording-exclusion-configs',
      },
      intent: {
        scriptListNestByOrgId: '/scripts/organizationId',
      },

      contactList: {
        getByOrgId: '/contact/lists/orgId', // Deprecated
        getByOrgIdPaginated: '/contact/lists/v2/orgId',
        getById: '/contact/lists',
      },

      contact: {
        getByContactListId: '/contacts/contactList',
        getById: '/contacts',
      },
      metrics: {
        // Combined build + disposition metrics in a single request.
        // URL is built as `${sessionSummary}/${callSessionId}/summary`.
        sessionSummary: '/metrics/session',
      },
    },

    post: {
      rabbit: {
        invalidate: '/rabbit/invalidate',
        invalidateSession: '/rabbit/session',
      },
      voicemail: {
        createVoicemailNest: '/recording',
      },
      intent: {
        scriptNest: '/scripts',
        generateAIScript: '/scripts/v1/ai-script',
      },
      callSession: {
        createNest: '/call-sessions',
      },
      callSessionConfig: {
        create: '/call-session-configs',
      },
      contactList: {
        create: '/contact/lists',
      },
      contact: {
        uploadCsvToContactList: '/contacts',
        createSalesforce: '/contacts/salesforce',
        createOutreach: '/contacts/outreach',
        createHubspot: '/contacts/hubspot',
        recycleByCallSessionIds: '/contacts/v2/recycle/call-session-ids',
      },
    },

    put: {
      callLog: {
        updateCallLog: '/call-logs/v2',
      },
      callSession: {
        updateNest: '/call-sessions',
        hangupNest: '/call-sessions/hangup',
        updateAgents: '/call-sessions/agents',
      },
      callSessionConfig: {
        updateByCallSessionId: '/call-session-configs/call-session',
      },
      contacts: {
        updateNotes: '/contacts/v2/notes',
      },
      voicemail: {
        updateVoicemailNest: '/recording',
      },
      intent: {
        editScriptNest: '/scripts',
      },

      contact: {
        update: '/contacts',
        updateFuegoLead: '/contacts/fuego-lead',
      },
    },

    delete: {
      voicemail: {
        deleteVoicemailNest: '/recording',
      },
      intent: {
        deleteScriptNest: '/scripts',
      },
      agentsFromSession: {
        removeAgentsFromSession: '/call-sessions/agents',
      },
      contactList: {
        delete: '/contact/lists',
      },

      contact: {
        delete: '/contacts',
      },

      sdrLogs: {
        deleteSdrLog: '/sdr-logs',
      },
    },
  },

  sync: {
    get: {
      featureFlags: {
        byOrg: '/feature-flags',
      },
      outreach: {
        getLinkedAccounts: '/outreach-configs/config',
        getSequencesSteps: '/outreach-configs/sequence-steps',
        getProspects: '/outreach-configs/prospects',
        mappings: {
          getMappingsByOrgId: '/outreach-mappings',
          getCustomDispositions: '/outreach-mappings/dispositions'
        },
        dashboard: '/dashboard/outreach',
      },
      salesforce: {
        getLists: '/salesforce-configs-custom/search',
        getReport: '/salesforce-configs-custom/reports',
        getContacts: '/salesforce-configs-custom/contact-lists/contacts',
        getSalesforceConfiguration: '/salesforce-configs-custom/config',
        getLinkedAccounts: 'salesforce-configs-custom/accounts',
        getMappings: '/salesforce-mappings',
        getCustomDispositions: '/salesforce-mappings/dispositions',
        oAuthLogin: '/salesforce-configs-custom/login',
        dashboard: '/dashboard/salesforce',
      },
      hubspot: {
        getLinkedAccounts: '/hubspot-configs/config',
        getContactsLists: '/hubspot-configs/contact-lists',
        getHubspotContacts: '/hubspot-configs/contact-lists/contacts',
        mappings: {
          getMappingsByOrgId: 'hubspot-mappings',
          getCustomDispositions: '/hubspot-mappings/dispositions',
        },
        dashboard: '/dashboard/hubspot',
      }
    },
    post: {
      featureFlags: {
        create: '/feature-flags',
      },
      salesforce: {
        updateJob: '/salesforce-jobs',
        saveSalesforceConfiguration: '/salesforce-configs-custom/config',
        updateMapping: '/salesforce-mappings',
        retryJob: '/salesforce-jobs/retry',
      },
      outreach:{
        oAuthLogin: '/outreach-configs/login',
        updateJob: '/outreach-jobs',
        mappings: {
          patchOutreachMapping: '/outreach-mappings',
          createOutreachDisposition : '/outreach-mappings/dispositions'
        },
        retryJob: '/outreach-jobs/retry',
      },
      hubspot: {
        oAuthLogin: '/hubspot-configs/login',
        updateJob: '/hubspot-jobs',
        mappings: {
          patchMapping: '/hubspot-mappings'
        },
        retryJob: '/hubspot-jobs/retry',
      }
    },
    put: {
      featureFlags: {
        upsert: '/feature-flags',
        update: '/feature-flags',
      },
      outreach: {
        mappings: {
          updateOutreachDisposition: '/outreach-mappings/dispositions/update',
        }
      },
    },
    delete: {
      outreach: {
        deleteLinkedAccount: '/outreach-configs/config',
        mappings: {
          deleteCustomDisposition: '/outreach-mappings/dispositions'
        }
      },
      salesforce: {
        deleteSalesforceAccount: '/salesforce-configs-custom/config',
      },
      hubspot: {
        deleteLinkedAccount: '/outreach-configs/config',
        mappings: {
          deleteDisposition: 'hubspot-mappings'
        }
      }
    },
  },

  auth: {
    get: {
      auth: {
        logout: '/user/logout',
        refreshSession: '/user/refresh',
        getMe: '/user/me',
      },
    },
    post: {
      auth: {
        login: '/user/login',
        resetPassword: '/user/reset_pass_auth',
        adminResetPassword: '/user/admin_reset_pass',
      },
    }
  },
} as const;
